import React, { PureComponent } from 'react';
import classNames from 'classnames';

// import './Accordion.css';
// import styles from './Accordion.css';
import styles from './Accordion.module.scss';

interface AccordionProps {
  isOpen?: boolean;
  label: string | JSX.Element;
  right?: boolean;
  preview?: JSX.Element;
  onToggle?: (flag: boolean) => void; // flag: true - openned, false - closed
}

interface AccordionState {
  isActive: boolean;
}

// TODO - цвет стрелки (раскрытия) сделать изменяемым
export default class Accordion extends PureComponent<AccordionProps, AccordionState> {
  constructor({ props }: { props: any }) {
    super(props);

    this.state = {
      isActive: false,
    };
  }

  public componentDidMount(): void {
    const { isOpen } = this.props;
    if (isOpen) {
      this.setState({ isActive: isOpen });
    }
  }

  public componentDidUpdate(prevProps: AccordionProps): void {
    if (prevProps.isOpen !== this.props.isOpen && typeof this.props.isOpen === 'boolean') {
      this.setState({ isActive: this.props.isOpen });
    }
  }

  private readonly changeToggle = () => {
    let { isActive } = this.state;
    isActive = !isActive;
    this.setState({ isActive }, () => {
      if (typeof this.props.onToggle === 'function') {
        this.props.onToggle(isActive);
      }
    });
  };

  public render() {
    const { isActive } = this.state;
    const { right, label, children: innerComponent, preview } = this.props;

    return (
      <div className={styles.root}>
        <div className={styles.headContainer}>
          {right ? (
            <>
              <span className={classNames(styles.label, styles.labelRight)}>{label}</span>
              <button
                className={classNames(styles.toggle, { [styles.toggleAfter]: isActive })}
                onClick={this.changeToggle}
              />
            </>
          ) : (
            <>
              <button
                className={classNames(styles.toggle, { [styles.toggleAfter]: isActive })}
                onClick={this.changeToggle}
              />
              <span className={styles.label}>{label}</span>
            </>
          )}
        </div>
        {/* При таком подходе проще сделать анимацию, но слайдеры криво отрисовываются
        <div className={isActive ? styles.accordion_panel__active : styles.accordion_panel}>
          {innerComponent}
        </div> */}
        {/* {isActive && <div className={styles.accordion_panel__active}>{innerComponent}</div>} */}
        <div className={styles.bodyContainer}>{isActive ? innerComponent : preview || null}</div>
      </div>
    );
  }
}
